import SearchIcon from '@mui/icons-material/Search';
import {
  Button, MenuItem, Select,
  TextField,
} from '@mui/material';
import React, {
  useEffect,
} from 'react';

function SearchColour({
  language, searchValue, setSearchValue, onSearch, onReset, colourType, setcolourType, setTabValue,
}) {
  const [searchBtnDisabled, setSearchBtnDisable] = React.useState(true);
  // const [searchLabel, setSearchLabel] = React.useState('Primary Colour');

  useEffect(() => {
    if (searchValue) {
      setSearchBtnDisable(false);
    } else {
      setSearchBtnDisable(true);
    }
  }, [searchValue]);

  const handleColourTypeChange = (event) => {
    setcolourType(event.target.value);
    setTabValue(event.target.value === 3 ? 1 : 0);
    setSearchValue('');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Select
        sx={{
          minWidth: 230,
          width: '250px',
          borderRadius: 30,
          height: '45px',
          backgroundColor: '#384451',
          color: 'white',
          fontWeight: 'bold',
          paddingX: 2,
          '& .MuiSelect-icon': { color: 'white' },
        }}
        labelId="action-label"
        id="action-select"
        label="Action"
        size="small"
        variant="outlined"
        value={colourType}
        onChange={handleColourTypeChange}
      >
        <MenuItem value={1}>{language === 1 ? 'Primary Colour' : 'Swatch Colour'}</MenuItem>
        <MenuItem value={2}>{language === 1 ? 'Swatch Colour' : 'Translated Colour'}</MenuItem>
        <MenuItem value={3}>Logs</MenuItem>
      </Select>
      <TextField
        sx={{
          mt: 3, ml: 0, mb: 3, minWidth: 100,
        }}
        label="Search"
        value={searchValue}
        onChange={(event) => setSearchValue(event.target.value)}
        variant="outlined"
        size="small"
        className="mr-6 w-[200px]"
        InputProps={{
          style: {
            borderRadius: 30,
            backgroundColor: '#E0F0F8',
            height: '45px',
            width: '200px',
          },
        }}
      />
      {(colourType !== 3)
        && (
          <>
            <Button
              startIcon={<SearchIcon />}
              sx={{
                ml: 10,
                borderRadius: 30,
                width: 330,
                height: '45px',
                backgroundColor: '#384451',
              }}
              variant="contained"
              disabled={searchBtnDisabled}
              onClick={() => onSearch(true)}
            >
              Search
            </Button>
            <Button
              sx={{
                borderRadius: 30,
                width: 330,
                height: '45px',
                backgroundColor: '#384451',
              }}
              variant="contained"
              onClick={onReset}
              size="small"
            >
              Reset
            </Button>
          </>
        )}
    </div>
  );
}

export default SearchColour;
